<template>
    <section class="media-library-detail">
        <slot name="title">
            <z-caption
                tag="h2"
                size="lt"
            >
                {{ data.item.name }}
            </z-caption>
        </slot>
        <div v-if="isVideo" class="media-library-detail__list">
            <media-card
                @click="$root.emitter.emit('open-modal', { id: 'media-library-detail-modal' })"
                :show-button="false"
                :label="data.item.name"
                :image="data.item.previewPicture.link"
            ></media-card>
        </div>
        <div v-else class="media-library-detail__list">
            <media-card v-for="(dataItem, index) in data.item.images"
                        @click="$root.emitter.emit('open-modal', { id: 'media-library-detail-modal', index: index})"
                        :show-button="false"
                        :label="dataItem.name"
                        :image="dataItem.link"
                        :show-content="false"
                        :isVertical="parseInt(dataItem.width) < parseInt(dataItem.height)"
            ></media-card>
        </div>

        <z-page-nav :data="data.nav" button-text="Вернуться к альбомам" class="u-mt-m"></z-page-nav>
    </section>

    <z-modal
        :download="!isVideo"
        :data="isVideo
            ? [{
                type: 'video',
                video: {
                    autoplay: false,
                    src: data.item.video.value,
                    preview: data.item.previewPicture.link
                },
                name: data.item.name
            }]
            : data.item.images.map(e => ({
                ...e,
                name: '',
                type: 'image'
            }))"
        class="media-library-detail__modal"
        id="media-library-detail-modal"
    >
    </z-modal>
</template>

<script setup>
import { computed } from 'vue';
import MediaCard from './components/MediaCard.vue';
import {useStore} from 'vuex';
import { localize } from '@/utils/i18n';

const store = useStore();
const pageTitle = localize({
    ru: 'Медиатека',
    en: 'Media-library',
    cn: 'Media-library'
})

const sliceText = (text) =>{
    return text.length > 60 ? `${text.slice(0,60)}...` : text
}

const setTitle = (title) => {
    store.dispatch('SetHeroTitle', title);
    store.dispatch('SetHeroTitleTag', 'h2');
};

setTitle(pageTitle);

// eslint-disable-next-line no-undef
const data = App.components['media-detail'];

const isVideo = computed(() => Boolean(data.item?.video?.value));
</script>

<style lang="scss">
.media-library-detail {
    &__list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: var(--spacer-m);

        @include breakpoint(tablet) {
            grid-template-columns: repeat(2, 1fr);
        }

        @include breakpoint(mobile) {
            grid-template-columns: 1fr;
        }
    }

    &__modal {
        $ZModalParent: '.z-modal';

        &-bottom-wrapper {
            user-select: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}
</style>
